__turbopack_context__.v({
  "accordion": "LightAccordion-module__QHzAnq__accordion",
  "details": "LightAccordion-module__QHzAnq__details",
  "detailsCollapsed": "LightAccordion-module__QHzAnq__detailsCollapsed",
  "expandIcon": "LightAccordion-module__QHzAnq__expandIcon",
  "expanded": "LightAccordion-module__QHzAnq__expanded",
  "faqAccordion": "LightAccordion-module__QHzAnq__faqAccordion",
  "faqDetails": "LightAccordion-module__QHzAnq__faqDetails",
  "faqDetailsCollapsed": "LightAccordion-module__QHzAnq__faqDetailsCollapsed",
  "faqExpanded": "LightAccordion-module__QHzAnq__faqExpanded",
  "faqSummary": "LightAccordion-module__QHzAnq__faqSummary",
  "faqSummaryText": "LightAccordion-module__QHzAnq__faqSummaryText",
  "rotated": "LightAccordion-module__QHzAnq__rotated",
  "summary": "LightAccordion-module__QHzAnq__summary",
  "summaryContent": "LightAccordion-module__QHzAnq__summaryContent",
});
